import React from "react";
import { 
  Wrapper,
  Container, 
  SectionTitle,
  Content, 
} from "./style";
import { Star } from "../Star";
import { FloatingMenu } from "../Menu/FloatingMenu";
import { YELLOW } from "../../constants/colors";
import { Footer } from "../Footer";

export const ContactPage = () => {

  return (
    
    <Wrapper>
      <Container>
        <SectionTitle>Contact Us</SectionTitle>
        <Content><a href="mailto:hello@takeflight.world"
                  rel="noreferrer"
                  target="_blank">hello@takeflight.world</a>
        </Content>
        <Star size={60} top={20} left={20} />
        <Star size={55} top={75 } left={60} />
      </Container>
    <FloatingMenu color={YELLOW}/>
    <Footer/>
    </Wrapper>
  )
};
